/* eslint-disable @typescript-eslint/camelcase */
import { call, put, takeLatest } from 'redux-saga/effects';
import { GetOperationsResponse } from '@card/types';
import { Services } from '@card/commonlib';
import OperationsActions, { OperationsActionType } from './actions';
import { getQueryString } from '../../utils/apiUtils';

function* fetchOperations(action: ReturnType<typeof OperationsActions.fetch>) {
  // TODO(dbelay): move getQueryString to commonlib and use it on the service
  const paramsQueryString = getQueryString(action.payload.pagination, action.payload.filters);
  try {
    const operationsResponse: GetOperationsResponse = yield call(
      Services.getOperations,
      paramsQueryString
    );
    yield put(
      OperationsActions.fetchSuccess({
        operations: operationsResponse.operations,
        settings: {
          current_page: action.payload.pagination.page,
          total_pages: operationsResponse.pages,
          total_elements: operationsResponse.total_operations,
          total: operationsResponse.total
        }
      })
    );
  } catch (error) {
    yield put(OperationsActions.fetchError(error));
  }
}

function* generateReport(action: ReturnType<typeof OperationsActions.generateReport>) {
  const paramsQueryString = getQueryString(action.payload.pagination, action.payload.filters);
  try {
    yield call(Services.generateOperationsReport, paramsQueryString);
    yield put(OperationsActions.generateReportSuccess());
  } catch (error) {
    yield put(OperationsActions.generateReportError(error));
  }
}

function* operationsSagas() {
  yield takeLatest(OperationsActionType.Fetch, fetchOperations);
  yield takeLatest(OperationsActionType.GenerateReportStarted, generateReport);
}
export default operationsSagas;
